import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { LocationService } from '../proxy/planning/controllers/location.service';
import { PropertyService } from '../proxy/planning/controllers/property.service';

FieldBuilder.setNamespace('Planning');

export const INTERNALROAD_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.InternalRoad.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .foreignKey('propertyId', 'Entity.Property', PropertyService)
    .required()
    .displayFromNested('property.name')
    .sortBy('property.name')
    .build(),
  FieldBuilder
    .foreignKey('locationId', 'Entity.Location', LocationService)
    .required()
    .displayFromNested('location.name')
    .sortBy('location.name')
    .hideInChildForms()
    .build(),
];

export const INTERNALROAD_CONFIG = {
  entityName: 'InternalRoad',
  localizationKey: 'Planning::Entity.InternalRoad',
  permission: 'GeneralLocations.InternalRoads',
  fields: INTERNALROAD_FIELDS,

  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Locations + MENU_NAME_SUFFIX,
};
